<template>
  <div id="app" class="h-full">
    <router-view />
    <FeedbackDialog v-if="feedbackVisible"/>
    <license-dialog :dialogOpen="dialogLicenseOpen" @toggleDialog="toggleDialog" @toggleDialogClose="toggleDialogLicenseClose" :mobileVersion="isLower1024"/>
    <wizard-dialog :dataWizard="dataWizard" :dialogOpen="dialogWizardOpen" @toggleDialog="toggleDialogWizard" @toggleDialogClose="toggleDialogWizardClose" :mobileVersion="isLower1024"/>
    <v-tour name="myTour" :steps="tourFirstStepsSteps" :options="toursOptions" :callbacks="tourFirstStepsCallbacks"></v-tour>
  </div>
</template>
<script>
import { i18n } from '@/i18n'
import FeedbackDialog from '@/components/FeedbackDialog.vue'
import LicenseDialog from '@/components/license/LicenseDialog.vue'
import WizardDialog from '@/components/wizard/WizardDialog.vue'
import { checkLicense } from '@/services/configurations/licenseUser/checkLicense'
import { checkWizard } from '@/services/wizard/checkWizard'

export default ({
  name: 'app',
  components: {
    FeedbackDialog,
    LicenseDialog,
    WizardDialog,
  },
  watch: {
    // Disparador de eventos solo la primera vez que se llega a una ruta privada de navegación
    $route: function () {
      if (!this.actualRoutePublic) {
        if (!this.controlFlagPatchNotes) {
          this.controlPatchNotes()
        }
        if (!this.controlFlagWizard && this.role === 2) {
          this.controlWizard()
        }
        if (!this.controlFlagLicense) {
          this.controlLicense()
        }
      }
    },
    isIdle: function (value, oldValue) {
      if (this.autoIdle && value && !this.actualRoutePublic) {
        this.$store.dispatch('auth/logout')
        this.doFeedback(i18n.t('feedback.info.expired_session_msg'), 'info', 5000)
      }
    }
  },
  data: function () {
    return {
      controlFlagPatchNotes: false, 
      dialogLicenseOpen: false,
      // Wizard
      dialogWizardOpen: false,
      dataWizard: null,
      //
      toursOptions: {
        // highlight: true,
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: i18n.t('app.skip'),
          buttonPrevious: i18n.t('app.back'),
          buttonNext: i18n.t('app.next'),
          buttonStop: i18n.t('app.finish')
        }
      },
      tourFirstStepsCallbacks: {
        onSkip: this.onSkipTourFirstSteps,
        onFinish: this.onSkipTourFirstSteps,
      },
      tourFirstStepsSteps: [
        {
          target: '[data-v-step="0"]', // We're using document.querySelector() under the hood
          content: i18n.t('tour.header'),
          params: {
            placement: 'right'
          },
          before: type => new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve()
            }, 500)
          })
        },
        {
          target: '[data-v-step="1"]',
          content: i18n.t('tour.step_1'),
          params: {
            placement: 'right'
          },
          before: type => new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve()
            }, 500)
          })
        },
        {
          target: '[data-v-step="2"]',
          content: i18n.t('tour.step_2'),
          params: {
            placement: 'top'
          },
          before: type => new Promise((resolve, reject) => {
            this.$router.push({ name: 'certificates' })
            setTimeout(() => {
              resolve()
            }, 500)
          })
        },
        {
          target: '[data-v-step="3"]',
          content: i18n.t('tour.step_3'),
          params: {
            placement: 'right'
          },
          before: type => new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve()
            }, 500)
          })
        },
        {
          target: '[data-v-step="4"]',
          content: i18n.t('tour.step_4'),
          params: {
            placement: 'top'
          },
          before: type => new Promise((resolve, reject) => {
            this.$router.push({ name: 'companies' })
            setTimeout(() => {
              resolve()
            }, 500)
          })
        }
      ],
    }
  },
  created: async function () {
    this.$store.dispatch('app/updateFrontColors')
    this.$store.dispatch('app/updateVersion')
    this.$store.dispatch('app/updatecontrolFlagLicense', false)
    this.$store.dispatch('app/updatecontrolFlagWizard', false)
    if (!this.actualRoutePublic) {
      await this.$store.dispatch('app/getColors')
      this.$store.dispatch('auth/reloadLocale')
    }
    this.$store.dispatch('app/updateFrontColors')
  },
  mounted () {  
    if (['dev', 'test'].includes(process.env.VUE_APP_ENVIRONMENT)) {
      document.title = 'EdasInvoiZE - LOCAL - DEV'
    } else {
      document.title = process.env.VUE_APP_TITLE
    }
    this.$root.$on('setControlFlagPatchNotes', () => {
      this.controlFlagPatchNotes = true
    })
  },  
  computed: {
    actualRoutePublic () {
      return this.$store.getters['app/actualRoutePublic']
    },
    feedbackVisible () {
      // !!! Propuestas deshabilitadas temporalmente !!!
      return false
      // return !this.actualRoutePublic
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    controlFlagLicense () {
      return this.$store.getters['app/controlFlagLicense']
    },
    controlFlagWizard () {
      return this.$store.getters['app/controlFlagWizard']
    },
    isIdle () {
      return this.$store.state.idleVue.isIdle
    },
    autoIdle () {
      return this.$store.getters['app/autoIdleTime']
    },
    role: function () {
      return this.$store.getters['auth/role']
    }
  },
  methods: {
    onSkipTourFirstSteps () {
    },
    controlPatchNotes () {
      if (!this.isEqualVersions()) {
        var self = this
        setTimeout(() => {
          self.doFeedback('EdasInvoiZE se ha actualizado con una nueva versión', 'info')
          if (self.isLower1024) self.$root.$emit('openNotesPatchMobile')
          else self.$root.$emit('openNotesPatch')
        }, 1500)
      }
    },
    isEqualVersions () {
      const splitOld= this.$store.getters['app/lastVisitedPatchNotes'].split('.')
      const splitActual = this.$store.getters['app/version'].split('.')
      if (splitOld[0] === splitActual[0] && splitOld[1] === splitActual[1] && splitOld[2] === splitActual[2]) return true
      return false
    },
    controlLicense: async function () {
      try {
        const response = await checkLicense()
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          if (response.Respuesta) {
            this.$store.dispatch('app/updatecontrolFlagLicense', true)
          } else {
            this.toggleDialog()
          }
        }
      } catch (error) {
        this.doFeedback()
      }
    },
    controlWizard: async function () {
      try {
        const response = await checkWizard()
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          if (!response.PendienteConfigurar) {
            this.$store.dispatch('app/updatecontrolFlagWizard', true)
          } else {
            this.dataWizard = {
              ListaSteps: response.ListaSteps,
              CurrentStep: response.CurrentStep,
              idPaqueteContratacion: response.idPaqueteContratacion,
              CerrarAlFinalizar: response.CerrarAlFinalizar,
            }
            this.toggleDialogWizard()
          }
        }
      } catch (error) {
        this.doFeedback()
      }
    },
    toggleDialog: function () {
      this.dialogLicenseOpen = !this.dialogLicenseOpen
      if (!this.dialogLicenseOpen) this.controlFlagLicense = true
    },
    toggleDialogWizard: function () {
      this.dialogWizardOpen = !this.dialogWizardOpen
      if (!this.dialogWizardOpen) this.controlFlagWizard = true
    },
    toggleDialogLicenseClose () {
      if (this.dialogWizardOpen) this.toggleDialogWizard()
    },
    toggleDialogWizardClose () {
      if (this.dialogLicenseOpen) this.toggleDialog()
    },
  }
})
</script>

<style lang="scss" src="@/assets/scss/overrides.scss">
</style>
